import styled from 'styled-components';

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    padding: 20px;
}`;

export const H1 = styled.h1`
    margin: 12px 0 20px 0;
    text-align: center;
`;

export const Ul = styled.ul`
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style: none;
    flex-wrap: wrap;
`;

export const Li = styled.li`
    margin: 4px 4px 28px 4px;
    padding: 0;
`;

export const A = styled.a`
    width: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: black;
    text-decoration: none;
`;

export const Img = styled.img`
    width: 80px;
`;
